import { memo } from 'react';

import { Text } from '@/components/core';
import { ClassificationFormatter, DateFormatter, findField, MappingFormatter, RegexFormatter } from '@/components/ui';
import {
  FORMATTER_CLASSIFICATION_FUNCTION_ID,
  FORMATTER_DATE_FUNCTION_ID,
  FORMATTER_MAPPING_FUNCTION_ID,
  FORMATTER_NUMERIC_FUNCTION_ID,
  FORMATTER_REGEX_FUNCTION_ID,
} from '@/constants';
import { useModelConfigStore } from '@/store';

import { NumericFormatter } from './NumericFormatter';

export type FormatterConfigurationProps = {
  fieldId: string;
  formatterId: string;
};

const IFormatterConfiguration = ({ fieldId, formatterId }: FormatterConfigurationProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const formatter = field?.formatters?.find((f) => f.id === formatterId);
  if (!formatter) return null;

  switch (formatter.functionId) {
    case FORMATTER_DATE_FUNCTION_ID:
      return <DateFormatter fieldId={fieldId} formatterId={formatterId} />;
    case FORMATTER_REGEX_FUNCTION_ID:
      return <RegexFormatter fieldId={fieldId} formatterId={formatterId} />;
    case FORMATTER_NUMERIC_FUNCTION_ID:
      return <NumericFormatter fieldId={fieldId} formatterId={formatterId} />;
    case FORMATTER_CLASSIFICATION_FUNCTION_ID:
      return <ClassificationFormatter fieldId={fieldId} formatterId={formatterId} />;
    case FORMATTER_MAPPING_FUNCTION_ID:
      return <MappingFormatter fieldId={fieldId} formatterId={formatterId} />;
  }
  return <Text>Unrecognized formatter</Text>;
};

export const FormatterConfiguration = memo(IFormatterConfiguration) as typeof IFormatterConfiguration;
